import React from 'react';
import InnerPageLayout from '../components/ui/InnerPageLayout';
import { Callout, ContentSection, InfoList } from '../components/ui/ContentBlocks';

function ChildSafety() {
  return (
    <InnerPageLayout
      tag="🛡️ Child Safety"
      title="Child Safety"
      titleAccent="Standards"
      description="Strapin is an adults-only platform. Protecting children is a non-negotiable commitment — not a policy checkbox. Last updated: February 2026."
      compactHero
    >
      <ContentSection title="Prohibition of Child Sexual Abuse and Exploitation (CSAE)">
        <p className="mb-4 text-silver leading-relaxed">
          Strapin explicitly prohibits any content or conduct that constitutes or facilitates child sexual abuse or exploitation (CSAE). We do not allow:
        </p>
        <InfoList
          bullet="❌"
          items={[
            'Content that sexually exploits or endangers minors in any way',
            'Content that depicts or promotes child sexual abuse material (CSAM)',
            'Conduct that grooms, solicits, or facilitates harm to minors',
            'Any activity that violates laws protecting children from sexual abuse or exploitation',
          ]}
        />
        <Callout>
          Violations result in <strong className="text-white">immediate account termination</strong>, reporting to relevant authorities where required by law, and full cooperation with law enforcement.
        </Callout>
      </ContentSection>

      <ContentSection title="Child Safety Commitments">
        <p className="mb-4 text-silver leading-relaxed">Strapin is designed exclusively for adults. Our commitments include:</p>
        <InfoList
          bullet="✓"
          items={[
            'Age restriction — Strapin requires all users to be at least 18 years old. We do not knowingly allow minors on the platform.',
            'Age verification — we verify age at the point of account creation and enforce this requirement strictly.',
            'Reporting tools — we provide in-app tools to report content or behaviour that may endanger children, and we act on all such reports promptly.',
            'Moderation and enforcement — child safety standards are enforced through policy, moderation practices, and technical measures.',
            'Legal compliance — we comply with all applicable laws regarding child safety, including mandatory reporting obligations where required by regulation.',
          ]}
        />
      </ContentSection>

      <ContentSection title="Scope and Application">
        <p className="leading-relaxed text-mist">
          These Child Safety Standards apply to the Strapin application and all services provided by Strapin, including as listed on Google Play and the Apple App Store under the app name &quot;Strapin&quot;. They form part of our commitment to a safe environment and supplement our Terms of Service and Community Guidelines.
        </p>
      </ContentSection>

      <ContentSection title="Contact and Reporting">
        <p className="mb-4 text-silver leading-relaxed">
          To report content or behaviour that may violate these standards or endanger a child, please use the in-app report tools or contact us directly. For urgent or law-enforcement matters, we cooperate with authorities as required by law.
        </p>
        <div className="glass-card p-5">
          <p className="text-mist">
            📧 Email:{' '}
            <a href="mailto:support@strapinapp.com" className="font-bold text-primary hover:underline">
              support@strapinapp.com
            </a>
          </p>
        </div>
      </ContentSection>

      <p className="text-sm text-silver">Last updated: February 2026. Strapin — Child Safety Standards.</p>
    </InnerPageLayout>
  );
}

export default ChildSafety;
